import { Grid, makeStyles, Button } from '@material-ui/core';
import React, { useRef, useState } from 'react';
import Input from '../../common/input';
import { CERTIFICATION } from '../../../constants/props';
import { updateCertification } from '../../../api/certification';
import useNotification from '../../../hooks/useNotification';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles({
  container: {
    display: 'flex',
  }
});

const Edit = ({ 
  hash,
  title: initialTitle, 
  institution: initialInstitution, 
  year: initialYear,
  onDelete,
  reloadCandidateUpdatedAtData
}) => {
  const classes = useStyles();
  const notification = useNotification();

  let { current: lastSavedTitle } = useRef(initialTitle);
  let { current: lastSavedInstitution } = useRef(initialInstitution);
  let { current: lastSavedYear } = useRef(initialYear);
  const [title, setTitle] = useState(initialTitle);
  const [institution, setInstitution] = useState(initialInstitution);
  const [year, setYear] = useState(initialYear);

  function handleSubmit() {
    if (lastSavedTitle !== title || 
        lastSavedInstitution !== institution || 
        lastSavedYear !== year) {
      updateCertification(hash, { immediately: true, title, institution, year }).then((res) => {
        if (res.success) {
          lastSavedTitle = title;
          lastSavedInstitution = institution;
          lastSavedYear = year;
          reloadCandidateUpdatedAtData();
          notification.success({ message: 'Certification was successfully updated', });
        } else notification.error(res.error);
      });
    }
  }

  function handleDelete() {
    onDelete(hash)
  }

  return (
    <Grid container className={classes.container} justify="space-around">
      <Grid item sm={3}>
        <Input
        placeholder="type a title"
        value={title}
        onChange={({ target }) => setTitle(target.value)}
        onBlur={handleSubmit}
        />
      </Grid>

      <Grid item sm={3}>
        <Input
          placeholder="type a institution"
          value={institution}
          onChange={({ target }) => setInstitution(target.value)}
          onBlur={handleSubmit}
        />
      </Grid>

      <Grid item sm={3}>
        <Input
          placeholder="select a year"
          value={year}
          onChange={({ target }) => setYear(target.value)}
          onBlur={handleSubmit}
        />
      </Grid>

      <Grid item>
        <Button variant="outlined" color="primary" onClick={() => handleDelete()}>
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      </Grid>
    </Grid>
  );
};

Edit.propTypes = {
  CERTIFICATION,
};

export default Edit;
